import oxQuiz from './modules/oxQuiz';
import common from './modules/common';

export default {
    dateFormat: '{year}년 {month}월 {day}일 ({dayOfWeek})',
    dayOfWeek: {
        sunday: '일',
        monday: '월',
        tuesday: '화',
        wednesday: '수',
        thursday: '목',
        friday: '금',
        saturday: '토',
    },
    dateSelect: '기간 선택',
    selector: {
        date: {
            title: '기간 선택',
            description: '시작일과 종료일을 선택해 주세요.',
            startDate: '시작일',
            endDate: '종료일',
        },
    },
    tab: {
        class: '수업/자습별',
        activity: '활동별',
        customManager: '수업 만들기',
        curriculum: '교과 수업',
    },
    subject: {
        korean: '국어',
        koreanActivity: '국어활동',
    },
    unit: {
        year: '년',
        month: '월',
        day: '일',
        point: '점',
        count: '개',
        num: '수',
        week: '주',
        date_day: '요일',
        person: '명',
        minutes: '분',
        chapter: '차시',
        etc: '외',
    },
    achievementState: {
        notProvided: '성취도 미제공',
        notParticipated: '일부 미참여',
    },
    button: {
        search: '검색',
        save: '저장',
        saving: '저장 중...',
        cancel: '취소',
        delete: '삭제',
        apply: '적용',
        edit: '편집',
        all: '전체',
        recent: '최근',
        start: '시작하기',
        next: '다음',
        list: '목록',
        show: '상세',
        more: '더보기',
        detail: '상세 정보',
        close: '닫기',
        confirm: '확인',
        register: '등록',
    },
    session: {
        start: {
            lecture: '수업 시작',
            self: '자습 시작',
            confirm: '선택한 차시로 {sessionMode}을 시작할까요?',
        },
        ongoing: {
            title: '수업 시작',
            message: '이미 진행중인 수업이 있어요.\n 수업 종료 후 새로운 수업을 시작해주세요.',
        },
        restart: {
            title: '{mode} 다시 하기',
            message: '이 {mode}을 다시 시작하시겠습니까?',
        },
        error: {
            title: '오류 발생',
            message: '{mode}을 시작하는 중 오류가 발생했습니다.',
        },
    },
    modules: {
        common: common,
        ox_quiz: oxQuiz,
    },
    mode: '모드',
    lecture: '수업',
    self: '자습',
    date: '날짜',
    sessionTitle: '수업명',
    result: '결과',
    pinNumber: 'PIN 번호',
    classroomNumber: '출석번호',
    name: '이름',
    email: '이메일',
    phone: '전화번호',
    champion: '챔피언',
    mvp: 'MVP',
    total: '누적',
    stars: '칭찬별',
    vocabulary: '어휘',
    writing: '쓰기',
    grammar: '문법',
    understanding: '이해',
    reading: '읽기',
    speaking: '말하기',
    inference: '추론',
    achievement: '성취도',
    activity: '활동',
    isCorrect: '정답',
    isIncorrect: '오답',
    question: '문항',
    achievementResult: '성과',
    detail: '상세',
};
